var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "message-stack" },
    [
      _c(
        "v-alert",
        {
          attrs: {
            value: _vm.alert,
            color: "warning",
            dark: "",
            border: "top",
            icon: "mdi-information",
            transition: "scale-transition",
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.messageData) + " "),
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.navigateToMessageCenter.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  },
                  [_vm._v("Click here to go to the message center")]
                ),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", small: "" },
                  on: {
                    click: function ($event) {
                      return _vm.closeMessage()
                    },
                  },
                },
                [_c("v-icon", { attrs: { small: "" } }, [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }